import type { ConceptListItem } from "@/types/concept";
import type { ZoteroSyncEvent } from "@/types/zoteroSync";

export type GroupedEvents =
  | {
      kind: "grouped";
      current: ZoteroSyncEvent[];
      others: ZoteroSyncEvent[];
      currentConceptName: string;
    }
  | { kind: "flat"; events: ZoteroSyncEvent[] };

export function groupEventsForBell(
  events: ZoteroSyncEvent[],
  currentConceptId: string | null,
  conceptList: Pick<ConceptListItem, "id" | "name">[],
): GroupedEvents {
  const valid = events.filter((e) => !!e.concept_id);
  if (!currentConceptId) {
    return { kind: "flat", events: valid };
  }
  const current: ZoteroSyncEvent[] = [];
  const others: ZoteroSyncEvent[] = [];
  for (const e of valid) {
    if (e.concept_id === currentConceptId) current.push(e);
    else others.push(e);
  }
  const currentConceptName =
    conceptList.find((c) => c.id === currentConceptId)?.name ?? "this concept";
  return { kind: "grouped", current, others, currentConceptName };
}

export function lookupConceptName(
  conceptId: string | null | undefined,
  conceptList: Pick<ConceptListItem, "id" | "name">[],
): string {
  if (!conceptId) return "";
  return conceptList.find((c) => c.id === conceptId)?.name ?? "";
}
